import React, { useEffect, useState, useContext } from "react";
import "./VdExteriorInterior.css";

import ext1 from "../../../../assets/images/voyahdream/exterior/ext1.jpg";
import ext2 from "../../../../assets/images/voyahdream/exterior/ext2.jpg";
import ext3 from "../../../../assets/images/voyahdream/exterior/ext3.jpg";
import ext4 from "../../../../assets/images/voyahdream/exterior/ext4.jpg";

import int1 from "../../../../assets/images/voyahdream/interior/int1.jpg";
import int2 from "../../../../assets/images/voyahdream/interior/int2.jpg";
import int3 from "../../../../assets/images/voyahdream/interior/int3.jpg";
import int4 from "../../../../assets/images/voyahdream/interior/int4.jpg";

import acc1 from "../../../../assets/images/voyahdream/accessories/acc1.jpg";
import acc2 from "../../../../assets/images/voyahdream/accessories/acc2.jpg";
import acc3 from "../../../../assets/images/voyahdream/accessories/acc3.jpg";
import acc4 from "../../../../assets/images/voyahdream/accessories/acc4.jpg";
import acc5 from "../../../../assets/images/voyahdream/accessories/acc5.jpg";

import { LanguageContext } from "../../../../context/LanguageContext";
import { getPageContent } from "../../../../api/publicContent.api";

const EXTERIOR_IMAGES = [ext1, ext2, ext3, ext4];
const INTERIOR_IMAGES = [int1, int2, int3, int4];
const ACCESSORIES_IMAGES = [acc1, acc2, acc3, acc4, acc5];

const VdSlider = ({ title, images }) => {
  const [index, setIndex] = useState(0);

  if (!images || images.length === 0) return null;

  const prev = () =>
    setIndex(index === 0 ? images.length - 1 : index - 1);

  const next = () =>
    setIndex(index === images.length - 1 ? 0 : index + 1);

  return (
    <section dir="ltr" className="vd-gallery-section">
      <h2 className="vd-gallery-title">{title}</h2>
      <span className="vd-gallery-line" />

      <div className="vd-slider">
        <img src={images[index]} alt={title} className="vd-slide-image" />

        <button className="vd-arrow vd-arrow-left" onClick={prev}>
          ‹
        </button>

        <button className="vd-arrow vd-arrow-right" onClick={next}>
          ›
        </button>

        <div className="vd-dots">
          {images.map((_, i) => (
            <span
              key={i}
              className={`vd-dot ${i === index ? "active" : ""}`}
              onClick={() => setIndex(i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

const VdExteriorInterior = () => {
  const { currentLang } = useContext(LanguageContext);

  const [titles, setTitles] = useState({
    exterior_title: "Exterior",
    interior_title: "Interior",
    accessories_title: "Accessories",
  });

  useEffect(() => {
    const loadGalleryText = async () => {
      try {
        const response = await getPageContent("voyahdream", currentLang);
        const gallery = response.sections?.gallery;

        if (gallery) {
          setTitles({
            exterior_title: gallery.exterior_title || "Exterior",
            interior_title: gallery.interior_title || "Interior",
            accessories_title: gallery.accessories_title || "Accessories",
          });
        }
      } catch (err) {
        console.error("Failed to load Voyah Dream gallery text", err);
      }
    };

    loadGalleryText();
  }, [currentLang]);

  return (
    <div className="vd-gallery-wrapper">
      <VdSlider title={titles.exterior_title} images={EXTERIOR_IMAGES} />
      <VdSlider title={titles.interior_title} images={INTERIOR_IMAGES} />
      <VdSlider title={titles.accessories_title} images={ACCESSORIES_IMAGES} />
    </div>
  );
};

export default VdExteriorInterior;
